module.exports = __webpack_public_path__ + "static/step-2-8498c874c368757b01b1ea4f238cb3c8.svg";